/* eslint-disable max-len */

import {
  CourtesyAssetData,
  CourtesyContent,
} from '@shared/api/courtesyAsset/courtesyAsset.interface';
import courtesyImage1 from 'src/assets/image/courtesy.png';
import courtesyImage2 from 'src/assets/image/courtesy2.png';

interface FallbackCourtesyDef {
  name: string;
  content: string;
}

const FALLBACK_COURTESY_LIST: FallbackCourtesyDef[] = [
  {
    name: '표준(기본)',
    content:
      '감사의 인사를 올립니다.\n\n' +
      '금번 저희 故${deceasedName}님 장례에 바쁘신 중에도 찾아주시고,\n저희 가족 위로해주심을 진심으로 감사드립니다.\n\n' +
      '큰 슬픔에 찬 저희 가족에게 따뜻한 위로가 되었습니다.\n고마움 오래오래 간직하겠습니다.\n\n' +
      '내내 건강하옵시고 귀댁의 가정에 항상 행운이 함께 하시길 기원합니다.\n\n' +
      '${dateString}\n${memberName} 배상',
  },
  {
    name: '표준(장문1)',
    content:
      '삼가 감사인사 드립니다.\n\n' +
      '공사간 바쁘신 중에도 불구하고\n금번 저희 故${deceasedName}님 장례에\n찾아주신 조문객님들의 위로 덕분에\n장례식을 무사히 마치게 됨을\n머리숙여 감사드립니다.\n\n' +
      '한분 한 분께 찾아뵙고 정중한 인사를\n드려야함이 마땅한 일이오나\n우선 서면으로 감사한 마음을 대신함을\n너그러운 마음으로 이해하여 주시면\n감사하겠습니다.\n\n' +
      '귀 댁에 대소사가 있을 때\n연락주시어 보답할 수 있는 기회를\n주시기를 부탁 드립니다.\n\n' +
      '귀하의 가정에 평안과\n뜻 하시는 모든 일이 형통하시길\n기원합니다.',
  },
  {
    name: '표준(장문2)',
    content:
      '삼가 감사인사 드립니다.\n\n' +
      '바쁘신 와중에도 어려운 자리에\n찾아주시고, 따뜻한 마음과 조의를\n표해주셔서 감사합니다.\n' +
      '전해주신 위로와 격려의 말씀이\n큰 힘이 되었습니다.\n' +
      '이 고마운 마음을 늘 간직하겠습니다.\n' +
      '항상 건강하시고 좋은 일 가득하시길\n진심으로 기원합니다.',
  },
  {
    name: '표준(단문1)',
    content:
      '바쁘신 와중에도 저희 故${deceasedName}님 장례에 찾아와주셔서 감사합니다.\n\n' +
      '보내주신 위로와 격려 덕분에\n슬픈 상황에서 큰 힘이 되었고,\n장례를 무사히 잘 마칠 수 있었습니다.\n\n' +
      '경황이 없어 글로 이렇게 감사함을 표현함에\n양해 부탁드리며, 찾아와 주셔서\n다시 한 번 감사드립니다.\n\n' +
      '늘 건강과 평안이 함께 하시길 바랍니다.\n\n' +
      '${dateString}\n${memberName} 배상',
  },
  {
    name: '표준(단문2)',
    content:
      '삼가 인사드립니다.\n\n' +
      '공사간에 여러가지로 바쁘심에도 불구하시고\n저희 故${deceasedName}님 장례에 찾아와 주시어,\n' +
      '따뜻한 위로의 말씀과 더불어 일일이 보살펴 주신 덕분에\n무사히 장례를 잘 모셨습니다.\n\n' +
      '저희들로서는 마땅히 직접 찾아뵙고\n인사를 드리는 것이 도리인 줄 아오나\n아직 경황이 없어 이처럼 글월로써 대신하오니\n너그러우신 마음으로 헤아려 주시기 바랍니다.\n\n' +
      '${dateString}\n${memberName} 배상',
  },
  {
    name: '표준(친우)',
    content:
      '친우야 바쁜시간 내주어 우리 故${deceasedName}님 장례에 찾아와주어 고맙다.\n\n' +
      '큰 슬픔을 나누어주어 우리 가족에게 많은 힘과 위로가 되었구나.\n\n' +
      '힘든 시기가 지나 소중한 일상을 함께 할 수 있길 바라며 항상 건강하고 행복이 가득하길 바란다.\n\n' +
      '${dateString}\n${memberName} 배상',
  },
  {
    name: '불교(예문1)',
    content:
      '감사의 인사를 올립니다.\n\n' +
      '금번 저희 故${deceasedName}님 장례에 바쁘신 중에도 찾아주시고, 저희 가족 위로해주심을 진심으로 감사드립니다.\n\n' +
      '큰 슬픔에 찬 저희 가족에게 따뜻한 위로가 되었습니다.\n고마움 오래오래 간직하겠습니다.\n\n' +
      '부처님의 세계에 고이 잠들 수\n있도록 기도해주신점 다시 한번\n감사 인사 드립니다.\n\n' +
      '${dateString}\n${memberName} 배상',
  },
  {
    name: '기독교(예문1)',
    content:
      '감사의 인사를 올립니다.\n\n' +
      '금번 저희 故${deceasedName}님 장례에 바쁘신 중에도 찾아주시고, 저희 가족 위로해주심을 진심으로 감사드립니다.\n\n' +
      '큰 슬픔에 찬 저희 가족에게 따뜻한 위로가 되었습니다.\n고마움 오래오래 간직하겠습니다.\n\n' +
      '주님의 은혜가 늘 함께하는\n평안의 가정 되시기를 기도드리며\n다시 한번 깊은 감사의 인사를 드립니다.\n\n' +
      '${dateString}\n${memberName} 배상',
  },
  {
    name: '천주교(예문1)',
    content:
      '감사의 인사를 올립니다.\n\n' +
      '금번 저희 故${deceasedName}님 장례에 바쁘신 중에도 찾아주시고, 저희 가족 위로해주심을 진심으로 감사드립니다.\n\n' +
      '큰 슬픔에 찬 저희 가족에게 따뜻한 위로가 되었습니다.\n고마움 오래오래 간직하겠습니다.\n\n' +
      '주님 안에서 편히 안식할 수 있게\n기도해주신점 다시 한번 감사드립니다.\n\n' +
      '${dateString}\n${memberName} 배상',
  },
];

const FALLBACK_ID_PREFIX = 'fallback-';

let fallbackIdCounter = 0;

export const isFallbackAsset = (id: string) => id.startsWith(FALLBACK_ID_PREFIX);

export const generateFallbackCourtesyContentList = (): CourtesyContent[] => {
  return FALLBACK_COURTESY_LIST.map((item) => ({
    _id: `${FALLBACK_ID_PREFIX}content-${fallbackIdCounter++}`,
    bugoBrand: '',
    name: item.name,
    content: item.content,
    createdAt: new Date(),
    updatedAt: new Date(),
  }));
};

export const generateFallbackCourtesyAssetList = (): CourtesyAssetData[] => [
  {
    _id: `${FALLBACK_ID_PREFIX}asset-1`,
    bugoBrand: '',
    backgroundImage: {
      _id: `${FALLBACK_ID_PREFIX}img-1`,
      url: courtesyImage1,
      name: 'courtesy1',
      createdAt: new Date(),
      updatedAt: new Date(),
    },
    textBox: { x0: 24, y0: 30, x1: 24, y1: 12 },
    name: '기본 1',
    order: 0,
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    _id: `${FALLBACK_ID_PREFIX}asset-2`,
    bugoBrand: '',
    backgroundImage: {
      _id: `${FALLBACK_ID_PREFIX}img-2`,
      url: courtesyImage2,
      name: 'courtesy2',
      createdAt: new Date(),
      updatedAt: new Date(),
    },
    textBox: { x0: 24, y0: 30, x1: 24, y1: 12 },
    name: '기본 2',
    order: 1,
    createdAt: new Date(),
    updatedAt: new Date(),
  },
];
